<template>
    <y-button
        class="panel-back mb-2 typo-subtitle-2 d-flex justify-content-start"
        :icon-prepend="$i18n.locale === 'en' ? 'arrow-left' : 'arrow-right'"
        color="body"
        size="small"
        @click.native="$router.go(-1)"
    >
        {{ $t('buttons.back') }}
    </y-button>
</template>

<script>
    export default {
        name: 'Back',
    };
</script>

<style lang="scss" src="./index.scss" />
